import { ArrowRight, MapPin, Phone, Mail } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden bg-brand-primary"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=1920&q=80')",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 hero-overlay" aria-hidden />
      <div className="absolute inset-0 grain" aria-hidden />

      {/* Vertical side label */}
      <div className="hidden lg:flex absolute left-8 top-1/2 -translate-y-1/2 origin-left -rotate-90 text-white/40 eyebrow z-10">
        Estabelecido em 2003 — São Paulo / SP
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-12 pb-24 pt-40">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            <p className="eyebrow text-brand-accent mb-6 animate-fade-up">
              <span className="thin-rule" />
              Galleti Advogados Associados
            </p>
            <h1 className="font-serif text-white font-light leading-[1.02] tracking-tight text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] animate-fade-up">
              Soluções jurídicas <em className="not-italic text-brand-accent">estratégicas</em><br />
              para pessoas e empresas.
            </h1>
            <div className="mt-8 space-y-4 text-white/80 text-base lg:text-lg max-w-2xl leading-relaxed animate-fade-up">
              <p>
                Mais do que atuar em processos, acreditamos na construção de soluções jurídicas
                inteligentes, seguras e alinhadas aos objetivos de cada cliente.
              </p>
              <p className="text-[15px] text-white/70">
                Com uma trajetória marcada pela excelência técnica, experiência prática e atuação
                estratégica, o escritório <span className="text-white/90">Carlos Afonso Galleti Junior
                Advogados Associados</span> oferece assessoria jurídica completa nas áreas consultiva,
                preventiva e contenciosa, atendendo pessoas físicas e jurídicas com proximidade,
                discrição e comprometimento com resultados.
              </p>
              <p className="font-serif italic text-brand-accent text-xl lg:text-2xl pt-2">
                Atuação moderna, humanizada e sem “juridiquês”.<br />
                <span className="text-white/70 not-italic text-[14px] tracking-wide">
                  Porque o Direito precisa ser claro, eficiente e relevante para quem busca segurança e proteção.
                </span>
              </p>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-5 animate-fade-up">
              <a
                href="#contato"
                data-testid="hero-cta-primary"
                className="group inline-flex items-center gap-3 bg-brand-accent text-brand-primary px-8 py-4 text-[12px] tracking-[0.25em] uppercase font-semibold hover:bg-white transition-colors"
              >
                Fale com um especialista
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="#areas-de-atuacao"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 text-white/90 hover:text-brand-accent text-[12px] tracking-[0.25em] uppercase font-medium link-underline"
              >
                Conheça as áreas
              </a>
            </div>
          </div>

          {/* Contact card */}
          <aside className="lg:col-span-4">
            <div className="bg-white/[0.04] backdrop-blur-md border border-white/10 p-8 lg:p-10">
              <p className="eyebrow text-brand-accent mb-6">Encontre-nos</p>
              <ul className="space-y-5 text-sm text-white/85">
                <li className="flex gap-3">
                  <MapPin size={18} className="text-brand-accent flex-shrink-0 mt-1" />
                  <span>Rua Santa Luzia, 48 — conj. 38<br />Liberdade, CEP 01503-030<br />São Paulo / SP</span>
                </li>
                <li className="flex items-center gap-3">
                  <Phone size={18} className="text-brand-accent flex-shrink-0" />
                  <a href="tel:+551131017576" className="hover:text-brand-accent" data-testid="hero-phone">(11) 3101-7576</a>
                </li>
                <li className="flex items-center gap-3">
                  <Mail size={18} className="text-brand-accent flex-shrink-0" />
                  <a href="mailto:contato@galleti.com.br" className="hover:text-brand-accent" data-testid="hero-email">contato@galleti.com.br</a>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>

      {/* Bottom marquee */}
      <div className="absolute bottom-0 inset-x-0 border-t border-white/10 bg-brand-primary/60 backdrop-blur-sm z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between text-[11px] tracking-[0.25em] uppercase text-white/60">
          <span>Consultivo · Preventivo · Contencioso</span>
          <span className="hidden md:inline">Pessoas físicas & jurídicas</span>
          <span className="hidden md:inline text-brand-accent">+ 20 anos de atuação</span>
        </div>
      </div>
    </section>
  );
}
